import React from 'react';

const InterviewSkeleton: React.FC = () => (
  <div className="max-w-lg mx-auto space-y-4 animate-pulse">
    <div className="h-10 bg-zinc-100 rounded-card" />
    <div className="h-40 bg-zinc-100 rounded-card" />
    <div className="h-28 bg-zinc-100 rounded-card" />
  </div>
);

export default InterviewSkeleton;